export default __webpack_public_path__ + "static/media/modal-mobile-drowpdown-selector.d3472940.svg";